import cache from '../src/js/cache';
import {lastClickEl} from '../src/js/const';


let siblingFadeTransition = Barba.BaseTransition.extend({

    start: function() {
        /**
         * This function is automatically called as soon the Transition starts
         * this.newContainerLoading is a Promise for the loading of the new container
         * (Barba.js also comes with an handy Promise polyfill!)
         */

        // As soon the loading is finished and the old page is faded out, let's fade the new page
        Promise
            .all([this.newContainerLoading, this.fadeOut()])
            .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
        /**
         * this.oldContainer is the HTMLElement of the old Container
         */

        let clickedItem = cache.get(lastClickEl);
        let parent = $(clickedItem).parent();
        const indexStart = $(clickedItem).parent().index();

        const numberOfRows = ($(parent).siblings().length + 1 ) / 4;



        //animate out categories
        let tl =  anime.timeline({
            opacity: 0,
            easing: 'easeInOutCubic',
            duration: 600,
        })

        tl.add({
            targets: '.categories .col-md-3',
            duration: 300,
            opacity: 0,
            scale: .9,
            delay: anime.stagger(150, {grid: [numberOfRows, 4], from: indexStart})
        });

        tl.add({
            targets: this.oldContainer,
            opacity: 0,
        },200);

        return tl.finished.then();

    },

    fadeIn: function() {
        /**
         * this.newContainer is the HTMLElement of the new Container
         * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
         * Please note, newContainer is available just after newContainerLoading is resolved!
         */

        let _this = this;
        let $el = $(this.newContainer);

        $(this.oldContainer).hide();

        $el.css({
            visibility : 'visible',
            opacity : 0
        });

        $el.animate({ opacity: 1 }, 400, function() {
            /**
             * Do not forget to call .done() as soon your transition is finished!
             * .done() will automatically remove from the DOM the old Container
             */

            _this.done();
        });
    }
});

export default siblingFadeTransition;
